var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"success"},[_vm._t("image"),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('base-submit-button',{staticClass:"btn btn-primary",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("button")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }